<app-page-title
  icon="fa-plug"
  [title]="integration ? integration.name : 'Integração'"
  data-testid="view-integration-section"
>
  <a class="btn btn-secondary" routerLink="/integration-sms">
    <i class="fa fa-arrow-left"></i> Voltar
  </a>
</app-page-title>

<form (submit)="load()">
  <div class="row col-md-12">
    <div class="col-md-12 col-sm-12" style="width: fit-content">
      <mat-form-field>
        <mat-label>Data inicial</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="startedMonth" name="startedMonth" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-12 col-sm-12" style="width: fit-content">
      <mat-form-field>
        <mat-label>Data final</mat-label>
        <input matInput [matDatepicker]="picker2" [(ngModel)]="endedMonth" name="endedMonth" />
        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="row col-md-12 col-sm-12 mb-4">
    <div class="col-12 d-flex">
      <div class="form-group pe-2" style="width: 90%">
        <label>Automação</label>
        <input
          type="text"
          name="text"
          [(ngModel)]="text"
          class="form-control"
          placeholder="Filtrar pelo nome da automação"
          data-testid="input-automation-filter"
        />
      </div>
      <div class="col-1 d-flex flex-column align-items-center justify-content-center mt-2">
        <!-- Ver o comentário do nível 1: `type="submit"` + `(click)` buscava duas vezes. -->
        <button
          class="btn btn-primary"
          style="width: fit-content; margin: auto"
          type="submit"
          [disabled]="invalidPeriod"
          data-testid="btn-search-automation"
        >
          <i class="fa fa-search"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Mesmo aviso do nível 1: uma mensagem para o par, o botão desabilitado junto. -->
  <div class="row col-md-12" *ngIf="invalidPeriod">
    <small class="text text-danger" data-testid="invalid-period">
      Período inválido: a data inicial é posterior à final.
    </small>
  </div>
</form>

<app-skeleton *ngIf="loading" variant="table-row" [count]="5" [columns]="6"
  label="Carregando as automações" data-testid="automations-loading"></app-skeleton>

<div *ngIf="!loading && automations.length > 0; else notFound" data-testid="automations-list">
  <div
    class="card automation-card mb-3"
    *ngFor="let automation of automations"
    (click)="openSends(automation)"
    data-testid="automation-item"
  >
    <div class="row align-items-center">
      <div class="col-md-3 col-sm-12">
        <label>Automação</label>
        <h5 class="automation-name" data-testid="automation-name">
          {{ automation.automation_name }}
          <small class="badge-unknown" *ngIf="!automation.automation">
            a plataforma não informou
          </small>
        </h5>
      </div>
      <div class="col-md-1 col-sm-4">
        <label>Mensagens</label>
        <p>{{ automation.total_sends | numberFormat }}</p>
      </div>
      <div class="col-md-1 col-sm-4">
        <label>Enviadas</label>
        <p>{{ automation.total_sent | numberFormat }}</p>
      </div>
      <div class="col-md-1 col-sm-4">
        <label>Erros</label>
        <p class="errors" [class.has-errors]="automation.total_errors > 0" data-testid="automation-errors">
          {{ automation.total_errors | numberFormat }}
        </p>
      </div>
      <!--
        Quantos passos de SMS a automação tem. Contado no TEMPLATE, não na
        mensagem enviada (que vem personalizada por contato). Quando a plataforma
        nunca declarou template não há como saber — aí é "-", nunca 0, que seria
        afirmar que a automação não tem passo nenhum.
      -->
      <div class="col-md-1 col-sm-4">
        <label>Passos</label>
        <p data-testid="automation-steps">
          {{ automation.has_message_info ? (automation.distinct_messages | numberFormat) : "-" }}
        </p>
      </div>
      <div class="col-md-4 col-sm-8">
        <label>Atividade</label>
        <p data-testid="automation-period">
          {{ automation.first_activity_at | date : "dd/MM/yyyy, H:mm" }}
          <span class="period-separator">até</span>
          {{ automation.last_activity_at | date : "dd/MM/yyyy, H:mm" }}
        </p>
      </div>
      <div class="col-md-1 col-sm-4 text-right">
        <a
          class="btn btn-secondary"
          [routerLink]="['/integration-sms/view', source, 'sends']"
          [queryParams]="automation.sendsParams"
        >
          <i class="fa fa-search"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #notFound>
  <div class="card" *ngIf="!loading">
    <div class="col" data-testid="no-automations">
      Nenhuma automação com envios para esta integração.
    </div>
  </div>
</ng-template>
